var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "#323338",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7458",
    "data-name": "Path 7458",
    d: "M22.03,5.8a1.284,1.284,0,0,0-1.818,0l-6.3,6.292-6.3-6.3A1.286,1.286,0,0,0,5.785,7.6l6.3,6.3-6.3,6.3A1.286,1.286,0,0,0,7.6,22.03l6.3-6.3,6.3,6.3a1.286,1.286,0,0,0,1.818-1.818l-6.3-6.3,6.3-6.3A1.292,1.292,0,0,0,22.03,5.8Z",
    transform: "translate(-5.407 -5.407)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.36e15cd3965c7855c2b320c22b51b38e.svg";
export { ForwardRef as ReactComponent };